import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Hotel, Home, Settings, Users, Tag, Gift,
  Percent, HelpCircle, Wifi, LogOut, Bell, CheckCircle, List, MessageSquare
} from 'lucide-react';
import { cn } from '../../lib/utils';

interface SidebarProps {
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { icon: Home, label: 'Inicio', path: '/home' },
    { icon: Users, label: 'Pasajeros', path: '/passengers' },
    { icon: Tag, label: 'Promociones', path: '/promotions' },
    { icon: Gift, label: 'Premios', path: '/rewards' },
    { icon: Percent, label: 'Descuentos Externos', path: '/discounts' },
    { icon: CheckCircle, label: 'Validar Canjes', path: '/redemptions/validate' },
    { icon: List, label: 'Gestión de Canjes', path: '/redemptions/manage' },
    { icon: MessageSquare, label: 'Consultas', path: '/contact-inquiries' },
    { icon: Bell, label: 'Notificaciones', path: '/notifications' },
    { icon: Wifi, label: 'WiFi', path: '/connections' },
    { icon: HelpCircle, label: 'Preguntas', path: '/questions' },
    { icon: Settings, label: 'Configuración', path: '/settings' },
  ];

  return (
    <div className="h-screen w-64 bg-slate-900 text-white flex flex-col border-r border-slate-800">
      {/* Logo */}
      <div className="p-6 border-b border-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <Hotel size={22} />
          </div>
          <div>
            <h1 className="font-semibold text-lg text-white">Chiavari</h1>
            <p className="text-xs text-slate-400">Backoffice</p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                'w-full flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors text-sm font-medium',
                isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-slate-300 hover:bg-slate-800 hover:text-white'
              )}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-slate-800">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-slate-300 hover:bg-slate-800 hover:text-white transition-colors text-sm font-medium"
        >
          <LogOut size={18} />
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
